import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  MapExportReportPreviewModalContainer, type MapExportReportPreviewModalModalProps,
} from './mapExportReportPreviewModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportReportPreview: MapExportReportPreviewModalModalProps;
  }
}

modalRenderer.register('ExportReportPreview', MapExportReportPreviewModalContainer);
